import {
    SET_ORDERS,
    SET_PRESCRIPTION_MEDICINES,
    SET_REQUISITION_MED,
    SET_INVENTORY_MED,
    SET_PATIENT_PACKET,
    SET_PARTNERS_LIST,
    CLEAR_PATIENT_PACKET,
    ADD_MED_TO_INVENTORY,
    EDIT_MED_TO_INVENTORY,
    DELETE_MED_FROM_INVENTORY,
    CLEAR_PRESCRIPTION_MEDICINES,
    CLEAR_INVENTORY_MEDICINES,
    SET_COMPARED_MEDS,
    UPDATE_COMPARED_MEDS,
    SET_EXPIRY_DATE,
} from '../ActionTypes/ActionTypes';

const initialState = {
    orders: [],
    patient_packet: '',
    requisition_medicines: [],
    prescription_medicines: [],
    inventorized_medicines: [],
    partners_list: [],
    compared_meds: [],
    expiry_date: '',
};

const InventoryReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_PARTNERS_LIST:
        // console.log(action);
        return {
            ...state,
            partners_list: action.payload.partners,
        };

    case SET_ORDERS:
        return {
            ...state,
            orders: action.payload.orders,
        };

    case SET_PRESCRIPTION_MEDICINES:
        return {
            ...state,
            prescription_medicines: action.payload.meds,
        };

    case ADD_MED_TO_INVENTORY:
        return {
            ...state,
            inventorized_medicines: state.inventorized_medicines.concat(action.payload.meds),
        };

    case EDIT_MED_TO_INVENTORY:
        state.inventorized_medicines.splice(action.payload.id, 1, action.payload.meds);
        return {
            ...state,
        };

    case DELETE_MED_FROM_INVENTORY:
        const updatedList = state.inventorized_medicines.filter(data => data.id !== action.payload.id);
        return {
            ...state,
            inventorized_medicines: updatedList,
        };

    case CLEAR_PRESCRIPTION_MEDICINES:
        return {
            ...state,
            prescription_medicines: [],
        };

    case SET_EXPIRY_DATE:
        return {
            ...state,
            expiry_date: action.payload.date,
        };

    case CLEAR_INVENTORY_MEDICINES:
        return {
            ...state,
            inventorized_medicines: [],
        };

    case SET_REQUISITION_MED:
        return {
            ...state,
            requisition_medicines: action.payload.meds,
        };

    case SET_INVENTORY_MED:
        return {
            ...state,
            inventorized_medicines: action.payload.meds,
        };

    case SET_PATIENT_PACKET:
        return {
            ...state,
            patient_packet: action.payload.packet_id,
        };

    case CLEAR_PATIENT_PACKET:
        return {
            ...state,
            patient_packet: '',
        };

    case SET_COMPARED_MEDS:
        return {
            ...state,
            compared_meds: action.payload.data,
        };

    case UPDATE_COMPARED_MEDS:
        state.compared_meds.splice(action.payload.id, 1, action.payload.values);
        return {
            ...state,
        };

    default:
        return state;
    }
};


export default InventoryReducer;



// WEBPACK FOOTER //
// ./src/Reducer/InventoryReducer.js